import React from 'react'
import { Layout } from './Layout';
function About() {
  return (
    <Layout>
    <h2>About page</h2>
    </Layout>)
}
export default About;
